import './articleTitle.scss'

const ArticleTitle = ({ text, titleClass, size }) => {
  const top = text?.split(' ').slice(0, 2).join(' ')
  const last = text?.split(' ').slice(2).join(' ')

  return (
    <h2 className={`Article-title ${titleClass}`}>
      <strong style={{ fontSize: size }} className="Article-title__strong">
        {top}
        {'   '}
      </strong>
      {'   '}

      {last}
    </h2>
  )
}

export default ArticleTitle
